import { postProtected } from './utils';

export var getEnd2EndLaunchUrl = function getEnd2EndLaunchUrl(playerSessionID, data) {
  return postProtected('/bingo/launch-end2end', playerSessionID, data);
};

export default {
  getEnd2EndLaunchUrl: getEnd2EndLaunchUrl
};